






import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store/types";
export default Vue.extend({
  name: "App",

  watch: {
    $route(to) {
      document.title = to.meta.title || "Ankieta";
    }
  },

  computed: {
    ...mapState({
      isSidebarOpen: state => (state as RootState).isSidebarOpen
    })
  },

  mounted(): void {
    if (navigator.appVersion.indexOf("Edge") != -1) {
      document.body.classList.add('edge');
    }
  }
});
